import { Routes } from '@angular/router';
import { AuthGuard } from '../../infrastructure/shared/services/auth.guard';
import { AdminPackagesPage } from './admin-packages-page/admin-packages-page';
import { AdminPackageDetails } from './admin-package-details/admin-package-details';
import { AdminClientsPage } from './admin-clients-page/admin-clients-page';
import { AdminClientDetails } from './admin-client-details/admin-client-details';
import { AdminAppointmentsPage } from './admin-appointments-page/admin-appointments-page';
import { AppointmentForm } from './appointment-form/appointment-form';
import { AdminNotifications } from './admin-notifications/admin-notifications';
import { AdminSettings } from './admin-settings/admin-settings';
import { AdminProfile } from './admin-profile/admin-profile';
import { AdminDashboard } from './admin-dashboard/admin-dashboard';

export const adminRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        data: {
          breadcrumb: 'Dashboard',
        },
        component: AdminDashboard,
        canActivate: [AuthGuard],
        pathMatch: 'full',
      },
      {
        path: 'packages',
        children: [
          {
            path: '',
            component: AdminPackagesPage,
            canActivate: [AuthGuard],
            pathMatch: 'full',
          },
          {
            path: ':id',
            component: AdminPackageDetails,
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: 'appointments',
        children: [
          {
            path: '',
            component: AdminAppointmentsPage,
            canActivate: [AuthGuard],
            pathMatch: 'full',
          },
          // {
          //   path: ':id',
          //   component: AdminPackageDetails,
          //   canActivate: [AuthGuard],
          // },
          {
            path: 'create',
            component: AppointmentForm,
            canActivate: [AuthGuard],
            data: { hideHeader: true },
          },
        ],
      },
      {
        path: 'clients',
        children: [
          {
            path: '',
            component: AdminClientsPage,
            canActivate: [AuthGuard],
            pathMatch: 'full',
          },
          {
            path: ':id',
            component: AdminClientDetails,
            canActivate: [AuthGuard],
          },
        ],
      },
      {
        path: 'notifications',
        component: AdminNotifications,
        canActivate: [AuthGuard],
      },
      {
        path: 'settings',
        component: AdminSettings,
        canActivate: [AuthGuard],
      },
      {
        path: 'profile',
        component: AdminProfile,
        canActivate: [AuthGuard],
      },
      { path: '**', redirectTo: 'dashboard' },
    ],
  },
  { path: '**', redirectTo: 'packages' },
];
